import { combineReducers } from "redux";
import { ReportState } from "./ReportReducer";

export const ReportReducer = combineReducers({
    ReportState: ReportState
});
